export { default as motherboard_transparent } from './motherboard_transparent.svg'
export { default as turquoise_ink } from './turquoise_ink.svg'
export { default as circle_notes } from './circle_notes.svg'
export { default as mountains } from './mountains.png'
export { default as oil56 } from './oil56.jpg'
export { default as oil2 } from './oil2.jpg'
